import { render, staticRenderFns } from "./ApprovalV2.vue?vue&type=template&id=30aa7748&scoped=true"
import script from "./ApprovalV2.vue?vue&type=script&lang=js"
export * from "./ApprovalV2.vue?vue&type=script&lang=js"
import style0 from "./ApprovalV2.vue?vue&type=style&index=0&id=30aa7748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa7748",
  null
  
)

export default component.exports